var _circle, _rect, _circle2, _circle3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#5CBA39",
    fillOpacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.8125,
    y: 15.4375,
    width: 37.4178,
    height: 34.125,
    rx: 5,
    fill: "#009CA6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.528,
    cy: 41.2116,
    r: 4.68621,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5868,
    cy: 41.2116,
    r: 4.68621,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3529 30.0909C27.0125 30.0909 26.6914 29.8976 26.5391 29.5671L23.3203 22.5945C23.1528 22.2319 23.1405 21.81 23.2858 21.4379C23.4305 21.0682 23.7105 20.7817 24.0743 20.6318C26.7729 19.5175 29.6268 18.9521 32.5565 18.9521C35.4882 18.9521 38.3433 19.5181 41.0423 20.6337C41.4056 20.7837 41.6851 21.069 41.8292 21.4376C41.9745 21.8078 41.9622 22.2285 41.7947 22.5906L38.5741 29.5672C38.3667 30.0149 37.8517 30.2122 37.3959 30.0149C35.8627 29.3499 34.2345 29.013 32.5559 29.013C32.2325 29.013 31.97 28.7505 31.97 28.4271C31.97 28.1037 32.2325 27.8412 32.5559 27.8412C34.3072 27.8412 36.0102 28.1764 37.6202 28.8378L40.7306 22.1002C40.7774 21.9988 40.7558 21.9098 40.7382 21.8658C40.7195 21.8172 40.6791 21.7522 40.5953 21.7177C38.0379 20.6602 35.3334 20.124 32.5564 20.124C29.7805 20.124 27.0772 20.6595 24.5215 21.7153C24.4365 21.7505 24.3955 21.8166 24.3762 21.8658C24.3464 21.9419 24.3486 22.0286 24.3833 22.1037L27.4919 28.8376C27.9448 28.6519 28.4106 28.4901 28.8787 28.3554C29.191 28.2652 29.5144 28.4457 29.6034 28.7568C29.693 29.0679 29.5132 29.3918 29.2021 29.4815C28.6982 29.6263 28.1985 29.8054 27.7157 30.0147C27.5973 30.0662 27.4738 30.0908 27.3524 30.0908L27.3529 30.0909Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.557 31.2557C32.557 31.9028 32.0323 32.4275 31.3853 32.4275C30.7382 32.4275 30.2135 31.9028 30.2135 31.2557C30.2135 30.6087 30.7382 30.084 31.3853 30.084C32.0323 30.084 32.557 30.6087 32.557 31.2557Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3844 31.8415C31.1219 31.8415 30.8835 31.664 30.8167 31.3974L28.4732 22.0234C28.3947 21.7099 28.5857 21.3919 28.8991 21.3132C29.2131 21.2341 29.5313 21.4257 29.6098 21.7397L31.9533 31.1137C32.0318 31.4272 31.8408 31.7452 31.5268 31.8238L31.3844 31.8414L31.3844 31.8415Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.36b64402ebf7b6b103d92269935189ba.svg";
export { ForwardRef as ReactComponent };